import { useAuthStore } from '@/modules/auth/store/auth';
import { storeToRefs } from 'pinia';

export default defineNuxtRouteMiddleware(async () => {
  const authStore = useAuthStore();
  const { data, getSession } = useAuth();
  const { user, hasLoggedInUser, isMerchant } = storeToRefs(authStore);

  if (!hasLoggedInUser.value) {
    await getSession();

    if (data.value?.data) {
      user.value = data.value.data as typeof user.value;
    }
  }

  if (!hasLoggedInUser.value) {
    return navigateTo('/merchant/login');
  }

  if (!isMerchant.value) {
    return navigateTo('/');
  }
});
